;(() => {
  const OMNI = '.omnisend-form-68c0da9d5b0ed73b09357876-teaser';
  const TARGET = '#google-merchantwidget-iframe-wrapper';

  const update = () => {
    const t = document.querySelector(TARGET);
    if (!t) return;

    const o = document.querySelector(OMNI);

    const force5 =
      !o || o.style.display === 'none';

    t.style.setProperty(
      'bottom',
      force5 ? '5px' : '125px',
      'important'
    );
  };

  update();

  new MutationObserver(update).observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['style'],
  });
})();
